/** @jsxImportSource @emotion/react */
import { Box, Icon, Text } from '@landtrustinc/design-system';
import React from 'react';

type LtPlusBenefitsListProps = {
  benefits: string[];
  helperText?: string;
};

const LtPlusBenefitsList: React.FC<LtPlusBenefitsListProps> = ({ benefits, helperText }) => {
  return (
    <Box display="flex" flexDirection="column" gap="var(--spacing-3)" width="100%">
      {helperText && (
        <Text size="sm" color="var(--text-primary)" textAlign="left">
          {helperText}
        </Text>
      )}

      <Box display="flex" flexDirection="column" gap="var(--spacing-3)" width="100%">
        {benefits.map((benefit) => (
          <Box key={benefit} display="flex" alignItems="center" gap="var(--spacing-3)">
            <Icon variant="Check" size="small" fill="#22c55e" />
            <Text fontWeight="semibold" color="var(--text-primary)">
              {benefit}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LtPlusBenefitsList;
